
import { LoadingScreen } from '@oncore/shared';
import { withUntitledUIRenderer } from '../UntitledUIRenderer';
import OncoreLoader from '@oncore/ui/shared/OncoreLoader';

export default withUntitledUIRenderer({
  legacy: LoadingScreen,
  untitledUI: OncoreLoader,
});
